storeValueIsStoreObject